export default __webpack_public_path__ + "images/a3d6773f6dca60a30732c338ec2f0a36-jewelry.webp";